module.exports = "<div id=\"videoReviewContainer--BottomPadding\" class=\"videoReviewContainer\">\n    <!-- <iframe width=\"100%\" height=\"100%\" frameBorder=\"0\" src=\"https://www.youtube.com/embed/D8XjXWcyyFM\">\n    </iframe>  -->\n    <iframe width=\"100%\" height=\"100%\" frameBorder=\"0\" [src]=\"this.safeUrl\">\n    </iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/videoEmbeded/videoEmbeded.component.html
// module id = ../../../../../src/app/components/videoEmbeded/videoEmbeded.component.html
// module chunks = main